import React from 'react'
import { AnyToken } from 'src/common/types/models/Tokens'
import useBalance from 'src/common/contracts/hooks/token/useBalance'
import { displayAmount } from 'src/common/utils/formatters/number'
import { useTranslation } from 'react-i18next'

type TokenBalanceProps = {
  StartAdornment?: React.ReactNode
  token: AnyToken | undefined
  ownerAddress: string | undefined // The address of the token owner
}

const TokenBalance: React.FC<TokenBalanceProps> = ({
  token,
  ownerAddress,
  StartAdornment,
}) => {
  const { balance, isLoading, error } = useBalance({
    token: token,
    owner: ownerAddress,
  })

  const { t } = useTranslation('common')

  const balanceEl = isLoading ? (
    <>
      <span>{StartAdornment} </span>
      <div className='text-center loader w-3 h-3 ml-1' />
    </>
  ) : (
    <>
      <span>{StartAdornment}</span> {balance ? displayAmount(balance) : '0'}
    </>
  )

  if (error) {
    return <div className='text-red-500'>{t('tokenBalance.error')}</div>
  }

  return (
    <span className='flex flex-row gap-2 items-center text-label1 font-normal text-secondary-contrast'>
      {balanceEl}
    </span>
  )
}

export default TokenBalance
